/*
 * @Author: zhangqf
 * @Date: 2018-11-26 14:57:40
 * @Last Modified by: Scherger
 * @Last Modified time: 2020-08-07 14:45:24
 */

import {
  SERVER,
  CONFIG
} from "@/api/apiConfig.js";
import sessionFun from "@/utils/cc-webapp/login.js";

import UTILS from "@/utils/utils.js";
import TOAST from "@/utils/vant.js";

import axios from 'axios';

//var _appId = "";
var _nativeData = "";

// function setAppId(appId) {
//   _appId = appId
// }

//设置应用信息
function setNative(data) {
  _nativeData = data
  // console.log("_nativeData>", _nativeData);
}

// 自定义判断元素类型JS
function toType(obj) {
  return ({}).toString.call(obj).match(/\s([a-zA-Z]+)/)[1].toLowerCase()
}
// 参数过滤函数
function filterNull(o) {
  for (var key in o) {
    if (o[key] === null) {
      delete o[key]
    }
    if (toType(o[key]) === 'string') {
      o[key] = o[key].trim()
    } else if (toType(o[key]) === 'object') {
      o[key] = filterNull(o[key])
    } else if (toType(o[key]) === 'array') {
      o[key] = filterNull(o[key])
    }
  }
  return o
}


/**
 * 区块请求方法
 * @param  {object} url  请求链接
 * @param  {String} params 是否显示区块(默认)
 * @param  {String} returnName 直接返回清单数据
 */
function blockAxios(url, params, returnName) {
  return this.doAxios(url, params, 'GET').then(res => {
    return returnName ? res[returnName] : res
  })
}

// 并发请求方法（多个接口同步同步）
/**
 * @example
 * this.GLOBAL_.ccRequest
        .allAxios(this.p1(), this.p2(), this.p2())
        .then(reload => {
          console.log("完成");
        });
 */
function allAxios() {
  return axios.all([].slice.call(arguments))
    .then(axios.spread(function (acct, perms) {
      // 两个请求现在都执行完成

      return {
        acct,
        perms
      }

    }));
}

/** 不带session請求方法
 * @param  {string} url 请求url
 * @param  {data} params 请求携带参数
 * @param  {string} method  默认POST  可传入 GET / POST
 */
function doAxios(url, params, method, isHttps) {
  let m = method ? method : "POST" //默认使用POST
  return new Promise(function (resolve, reject) {

    return apiAxios(m, url, params).then(res => {
      resolve(res)
    }).catch(e => {
      reject(e)
    })

  })

}

/**  将请求结果缓存到本地
 * @param  {Object} data 所有参数
 * @param  {Object} url url请求
 * @param  {Object} params 参数
 * @param  {Object} id  params中的id 参数
 * @param  {Object} method 请求类型
 * @param  {Object} isLogin 是否需要跳转login
 * @param  {Object} isSession  外部传入session，
 *
 */
function setRequestData(data, sendId, url) {

  // console.log('setRequestDataFun', data);



  if (SERVER.DEV) {
    return
  }

  // var requestStorage = native.getStorage('request_data');
  var requestStorage = null;
  var requestD = {}
  var isStorage = false

  var dataId = ''
  var setUrl = ''


  if (data.id) {
    dataId = data.id
  }

  if (sendId) {
    dataId = sendId
  }


  if (url) {
    setUrl = url
  } else {
    setUrl = data.url
  }




  if (requestStorage) {
    var epubRequest = JSON.parse(requestStorage)

    //request有缓存
    requestD = epubRequest

    for (const storageUrl in epubRequest) {
      const v = epubRequest[storageUrl];

      if (storageUrl == setUrl) {
        // console.log('setRequestData run this 1', data);

        // 有缓存过 覆盖
        isStorage = true
        requestD[storageUrl] = data
      } else if (storageUrl == (setUrl + '_' + dataId)) {
        // console.log('setRequestData run this 2', data);

        //url_id 的數據緩存形式
        isStorage = true
        requestD[setUrl + '_' + dataId] = data
      }

    }
  }

  if (!requestStorage || !isStorage) {
    //request 没有缓存
    // console.log('setRequestData run this 3', data);

    if (dataId) {
      //帶有id的形式

      requestD[setUrl + '_' + dataId] = {}
      requestD[setUrl + '_' + dataId] = data
    } else {
      requestD[setUrl] = {}
      requestD[setUrl] = data
    }

  }

  console.log('setStorage', setUrl, requestD, data);

  var setData = {
    key: 'request_data',
    value: JSON.stringify(requestD)
  };


  // native.setStorage(JSON.stringify(setData));

}


/** 没网状态将请求记录缓存到本地
 * @param  {Object} data 所有参数
 * @param  {Object} url url请求
 * @param  {Object} params 参数
 * @param  {Object} method 请求类型
 * @param  {Object} isLogin 是否需要跳转login
 * @param  {Object} isSession  外部传入session，
 *
 */
function setStorage(data) {
  // console.log('setStorage');

  if (SERVER.DEV) {
    return
  }

  var requestStorage = null;
  // var requestStorage = native.getStorage('epub_request');
  var requestD = {}
  var isStorage = false

  if (requestStorage) {
    var epubRequest = JSON.parse(requestStorage)

    //request有缓存
    requestD = epubRequest

    for (const storageUrl in epubRequest) {
      const v = epubRequest[storageUrl];

      if (storageUrl == data.url) {
        // 有缓存过
        if (storageUrl == CONFIG.OPERATE.ADD) {
          requestD[storageUrl] = []
        }

        if (requestD[storageUrl].length > 0) {
          var flag = false
          requestD[storageUrl].forEach(d => {
            if (JSON.stringify(d) == JSON.stringify(data)) {
              //已经有重复
              flag = true;
            }
          })
          if (!flag) {
            isStorage = true
            requestD[storageUrl].push(data)
          }

        } else {
          isStorage = true
          requestD[storageUrl].push(data)
        }


      }

    }
  }

  if (!requestStorage || !isStorage) {
    //request 没有缓存
    requestD[data.url] = []
    requestD[data.url].push(data)
  }


  //指定的url用于缓存返回的数据
  if (data.url == 'api/media/epub/token' || data.url == 'api/media/epub/note/query' || data.url == 'api/media/epub/note/queryByParagraph') {

    if (!data.resultData || data.url == 'api/media/epub/note/queryByParagraph') {
      return
    }
    // console.log('缓存缓存缓存', data, data.params.mediaId);
    let resulAll = {}
    resulAll['resultData'] = data.resultData
    resulAll.url = data.url
    let mId = ''
    if (data.url == 'api/media/epub/token') {
      mId = data.params.id
    } else {
      mId = data.params.mediaId
    }

    // console.log('resulAll', resulAll);


    setRequestData(resulAll, mId)
    // var resultData = {
    //   key: 'request_data',
    //   value: JSON.stringify(requestD)
    // };

    // native.setStorage(JSON.stringify(resultData));
  } else {

    // alert('epub_request')
    // alert(JSON.stringify(requestD))

    //缓存请求url
    var setData = {
      key: 'epub_request',
      value: JSON.stringify(requestD)
    };

    //檢查網絡，並根據網絡設置緩存
    // UTILS.checkNetWork(0)
    //   .then(() => {
    //     // alert('set ssstorage')
    //     //没网 或者未知情况
    //     native.setStorage(JSON.stringify(setData));

    //   })
    //   .catch(() => {});


  }



}

/**
 *  返回缓存中的数据
 *
 * @param  {String} url
 */
function returnStorageData(url) {

  if (SERVER.DEV) {
    return
  }

  var requestStorage = null
  // var requestStorage = native.getStorage("request_data");

  if (requestStorage) {
    //存在缓存

    // alert('returnStorageData ' + url)

    // alert(requestStorage)

    let storageD = JSON.parse(requestStorage)

    for (const storageUrl in storageD) {

      if (url == storageUrl) {
        // alert('requestStorage find ' + JSON.stringify(storageD[storageUrl]));

        return storageD[storageUrl];
      }

    }

  } else {
    //没有缓存
    return false
  }


}

/** 带session请求
 * @param  {string} url 请求url
 * @param  {data} params 请求携带参数
 * @param  {string} method  默认POST  可传入 GET / POST
 * @param  {Boolean } isLogin  是否需要跳转login
 * @param  {string } isSession  外部传入session，
 * @param  {string } isStorage  是否缓存， 默认不缓存
 * @Examples
 * isLogin 为检查session 当为空的时候是否需要跳转登录页判断，
 * 为兼容以调用过的请求， 所以默认为跳转登录页
 * 按照调用语义 ，调用的时候可传入 ‘no login’
 * doSessionAxios(url, params, method, 'no login')
 * @Examples
 * isSession 为外部传入，默认不传入自动获取本地session，
 * 当前用于新用户注册邮箱预传入，绑定成功才缓存到本地。
 *
 */
function doSessionAxios(url, params, method, isLogin, isSession, isStorage) {

  let m = method ? method : "POST" //默认使用POST
  var loginFlag = true

  if (isLogin) {
    loginFlag = false
  }

  return new Promise(function (resolve, reject) {
    console.log("doSessionAxios", isLogin,url);
    //如果存在外部传入session就使用外部的
    if (isSession) {
      return apiAxios(m, url, params, isSession).then(res => {
        //缓存数据
        if (isStorage) {
          setStorage({
            requestType: 'doSessionAxios',
            url: url,
            params: params,
            method: method,
            isLogin: isLogin,
            isSession: isSession,
            resultData: res
          })
        }
        resolve(res)

      }).catch(e => {
        //缓存数据
        if (isStorage) {
          setStorage({
            requestType: 'doSessionAxios',
            url: url,
            params: params,
            method: method,
            isLogin: isLogin,
            isSession: isSession,
          })
        }
        if (e.response.status == 500) {
          UTILS.showToast("網絡請求失敗");
        }

        if (e.response.status == 401 || e.response.data.code == 40101) {
          // if(native){
            // native.removeStorage('app_session');
            localStorage.removeItem('app_session');
            UTILS.showToast("用戶已過期請退出重新登錄");
            if(loginFlag){
              if( e.response.data.code == 40101){
                sessionFun.go()
              }
            }
          // }

        } else if (e.response.data.code == 40102) {

          UTILS.showToast("該用戶已被系統停用");

        } else {
          reject(e)
        }
      })

    } else {
      return sessionFun.get(loginFlag).then(w_session => {
        console.log("loginFlag", loginFlag);
        //不跳登錄頁且沒有獲取到session時
        if (loginFlag && w_session.session == null) {
          let e = {
            isLogin: false
          }
          reject(e)
        }
        return apiAxios(m, url, params, w_session).then(res => {
          //缓存数据
          if (isStorage) {
            setStorage({
              requestType: 'doSessionAxios',
              url: url,
              params: params,
              method: method,
              isLogin: isLogin,
              isSession: isSession,
              resultData: res
            })
          }
          resolve(res)

        }).catch(e => {
          console.log("err", e);
          //缓存数据
          if (isStorage) {
            setStorage({
              requestType: 'doSessionAxios',
              url: url,
              params: params,
              method: method,
              isLogin: isLogin,
              isSession: isSession,
            })
          }

          if (e.response.status == 500) {
            UTILS.showToast("網絡請求失敗");
          }

          if (e.response.status == 401 || e.response.data.code == 40101) {
              localStorage.removeItem('app_session');
              UTILS.showToast("用戶已過期請退出重新登錄");
              if(loginFlag){
                if( e.response.data.code == 40101){
                  sessionFun.go()
                }
              }
          } else if (e.response.data.code == 40102) {
            UTILS.showToast("該用戶已被系統停用");
          } else {
            reject(e);
          }
        })

      })

    }

  })

}

// 底层请求方法
function apiAxios(method, url, params, app_session, isHttps) {
  return new Promise(function (resolve, reject) {
    var sendUrl = SERVER.URL + url

    if (isHttps) {
      sendUrl = url
    }

    //过滤空参数
    if (params) {
      params = filterNull(params)
    }

    let obj = {}
    obj['method'] = method
    obj['url'] = sendUrl
    obj['data'] = method === 'POST' || method === 'PUT' ? params : null
    obj['params'] = method === 'GET' || method === 'DELETE' ? params : null
    obj['headers'] = {
      //'Content-type': 'application/x-www-form-urlencoded',
      'appId': SERVER.APPID,
    }

    if (app_session && app_session.session != null) {
      obj['headers']['session'] = app_session.session
    }

    obj['withCredentials'] = false
    obj['transformRequest'] = [function (data) {
      let ret = ''
      for (let it in data) {
        if (data[it] instanceof Array) {
          // 数组
          for (let item in data[it]) {
            ret += encodeURIComponent(it) + '=' + encodeURIComponent(data[it][item]) + '&'
          }
        } else {
          ret += encodeURIComponent(it) + '=' + encodeURIComponent(data[it]) + '&'
        }
      }
      return ret
    }]

    axios(obj).then((res) => {
      resolve(res.data)
    }).catch((err) => {
      reject(err)
    })

  })

}


function merge(url, obj) {

  //構造請求體
  let postD = [];
  for (let i in obj) {
    let d = {
      id: i
    }
    let item = obj[i];
    let u = item.url + "?"
    let pStr = '';
    for (let p in item.param) {
      let pVal = item.param[p];
      if (typeof (pVal) === "Object") {
        pStr += `&${p}=${JSON.stringify(pVal)}`
      } else {
        pStr += `&${p}=${pVal}`
      }
    }
    u += pStr;
    d.url = u;
    postD.push(d)

  }
  url += "?data=" + encodeURIComponent(JSON.stringify(postD)); //不知道為什麼，反正這樣可以

  return apiAxios("GET", url, {}).then(res => {
    //將結果裝入OBJ
    for (let idx in res) {
      let id = res[idx].id;
      obj[id].data = res[idx].result
    }
    return obj
  }).catch(e => {
    // console.log(e);
    return e
  })

}

export default {
  //setAppId,
  doAxios,
  blockAxios,
  allAxios,
  merge,
  doSessionAxios,
  setNative,
  setRequestData,
  // downloadOther
}



// WEBPACK FOOTER //
// ./src/utils/cc-webapp/request.js